// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import api from './api'
import store from './store/'
import './utils/flexible';
import './assets/common/common.css';
import './assets/common/globalstyle.less';
import './assets/common/screenAuto.css'
import './router/permission';
import './assets/fonts/font.css'
import './router/permission'

import moment from "moment";

//-----------------------element ui-----------------------
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI);

Vue.config.productionTip = false

Vue.prototype.$api = api;
Vue.prototype.$moment = moment;

import VueSocketIO from 'vue-socket.io';
Vue.use(new VueSocketIO({
  debug: false,
  connection: process.env.WEB_SOCKET_URL,
  vuex: {}
}))


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js